import React, { useState } from 'react';
import { RootDataContext } from './RootDataContext';
import { getRootAttributes } from '@utils';

/**
 * Wrapper to make a Provider for the RootDataContext.
 * @returns {React.Provider<RootDataContext>}
 */
const RootDataProvider = ({ children }) => {
    const [rootData] = useState(getRootAttributes());

    return (
        <RootDataContext.Provider value={rootData}>
            {children}
        </RootDataContext.Provider>
    );
};

export default RootDataProvider;
